import { SvgIcon, Tooltip } from '@mui/material';
import { RiErrorWarningFill, RiInformation2Line } from '@remixicon/react';
import { ReactNode } from 'react';

export interface InputHeaderProps {
  children?: ReactNode;
  helperText?: string;
  warningText?: string;
  className?: string;
  required?: boolean;
}

const InputHeader = ({
  children,
  helperText,
  warningText,
  required = false,
  className,
}: InputHeaderProps) => (
  <header className={className}>
    <span>{children}</span>
    {required && <span className="text-iots-red-500">*</span>}
    {helperText && (
      <Tooltip title={helperText}>
        <div className="inline-block relative cursor-help">
          <SvgIcon
            className="h-4 -translate-y-1 opacity-60"
            component={RiInformation2Line}
          />
        </div>
      </Tooltip>
    )}
    {warningText && (
      <Tooltip title={warningText}>
        <div className="inline-block relative cursor-help">
          <SvgIcon
            color="warning"
            className="h-4 -translate-y-1"
            component={RiErrorWarningFill}
          />
        </div>
      </Tooltip>
    )}
  </header>
);

export default InputHeader;
